import trackCustomerActions, { CustomerActionsType } from '@spa/lib/tracking/trackCustomerActions';

export const trackSuccessfulCheckout = (
  userId: string | null,
  guestId: string,
  { country, city, zip }: { country?: string; city?: string; zip?: string }
): void => {
  trackCustomerActions(
    { type: CustomerActionsType.CHECKOUT_SUCCESSFUL, city, country, zip },
    guestId,
    userId
  );
};
